import React, { useEffect, useState, useMemo } from "react";
import AdvisorMainContent from "../layout/AdvisorMain";
import Card1 from "./AdvisorCard";
import { apiServices } from "../services/Api";
import Loader from "../components/Loader";

const ArchivedCalls = () => {
  const [cardData, setCardData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAdvisorCardData = async () => {
      try {
        setIsLoading(true);
        const response = await apiServices.get("advisors/calls/archived");
        const data = Array.isArray(response) ? response : [];
        setCardData(data);
      } catch (error) {
        console.error("Error fetching advisor data:", error);
        setCardData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAdvisorCardData();

    const refreshInterval = setInterval(() => {
      console.log("Auto-refreshing archived calls data...");
      fetchAdvisorCardData();
    }, 300000);

    return () => clearInterval(refreshInterval);
  }, []);

  const archivedCallsData = useMemo(() => {
    console.log("Received archived calls from API:", cardData.length);

    return [...cardData].sort(
      (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
    );
  }, [cardData]);

  return (
    <AdvisorMainContent>
      <div className="px-4 py-6 lg:px-4 xl:px-6">
        <div className="mb-6 bg-white shadow-sm border-b border-t border-brand-border">
          <div className="flex items-center justify-between p-4 lg:p-6">
            <div>
              <h2 className="text-xl lg:text-[24px] xl:text-[24px] font-bold text-[#454545]">
                Archived Calls
              </h2>
              <p className="text-sm text-gray-500 mt-1">
                View and manage your archived trade calls
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 lg:gap-5 items-center pb-6">
          {isLoading ? (
            <Loader />
          ) : archivedCallsData.length > 0 ? (
            <>
              <div className="w-full mb-4">
                <p className="text-sm text-gray-600">
                  {archivedCallsData.length} archived call
                  {archivedCallsData.length !== 1 ? "s" : ""}
                </p>
              </div>
              {archivedCallsData.map((call) => (
                <Card1
                  key={`archived-${call.id}`}
                  data={call}
                  isArchived={true}
                />
              ))}
            </>
          ) : (
            <div className="text-center py-12">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                />
              </svg>
              <h3 className="mt-2 text-sm font-medium text-gray-900">
                No archived calls
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                Archive calls from your dashboard to see them here.
              </p>
            </div>
          )}
        </div>
      </div>
    </AdvisorMainContent>
  );
};

export default ArchivedCalls;
